module.exports = __webpack_public_path__ + "img/8f9bdef341e67cb046e31a29719a08b3.svg";